import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { headerSet } from "../../Helper/CssHelper";
// import './notfoundstyle.css';

function NotFound404() {
  let stylePath = "assets/css/notfoundstyle.css";
  useEffect(() => {
    headerSet();
    var head = document.head;
    var link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = stylePath;

    head.appendChild(link);

    return () => {
      head.removeChild(link);
    };
  }, [stylePath]);
  return (
    <div id="404Page" className="services section-show mt-5">
      <div>
        <div className="noise"></div>
        <div className="overlay"></div>
        <div className="terminal">
          <h1>
            Error <span className="errorcode">404</span>
          </h1>
          <p className="output">
            The page you are looking for might have been removed, had its name
            changed or is temporarily unavailable.
          </p>
          <p className="output">
            Please <Link to="/">return to the homepage</Link>.
          </p>
          <p className="output">Good luck.</p>
        </div>
      </div>
    </div>
  );
}

export default NotFound404;
